import PropTypes from 'prop-types';

export default PropTypes.shape({
  pathname: PropTypes.string.isRequired,
});
